import {Component, EventEmitter, Input, Output} from '@angular/core';
import {InvestmentNavigator} from '../../../utils/investment-navigator';
import {PreferredCategories} from '../../../model/portfolio-preferences.model';
import {AutoInvestPortfolioCreationData} from '../../../model/portfolio-creation-data/auto-invest-portfolio-creation.data';

@Component({
    selector: 'app-auto-invest-no-loans',
    styleUrls: ['auto-invest-no-loans.component.scss'],
    templateUrl: './auto-invest-no-loans.component.html'
})
export class AutoInvestNoLoansComponent {
    @Input()
    public portfolioCreationData: AutoInvestPortfolioCreationData;
    @Output()
    public readonly onInvestmentConfirmed = new EventEmitter<void>();
    @Output()
    public readonly onPreferredCategoriesChanged = new EventEmitter<PreferredCategories[]>();
    public shouldShowLoader = false;
    private readonly investmentNavigator: InvestmentNavigator;

    constructor(investmentNavigator: InvestmentNavigator) {
        this.investmentNavigator = investmentNavigator;
    }

    createPortfolio() {
        this.shouldShowLoader = true;
        this.onInvestmentConfirmed.emit();
    }

    onFindLoansClicked(preferredCategories: PreferredCategories[]) {
        this.onPreferredCategoriesChanged.emit(preferredCategories);
    }

    navigateToManualInvest() {
        this.investmentNavigator.navigateToManualInvestListingPage(this.portfolioCreationData.portfolioAmount);
    }
}